"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermService = void 0;
var axios_1 = __importDefault(require("axios"));
var TermService = (function () {
    function TermService(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        this.token = token;
        this.profileId = profileId;
    }
    TermService.prototype.getTermList = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/terms/");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            },
                            params: __assign(__assign({}, params), { limit: 999999, offset: 0 })
                        };
                        return [4, axios_1.default.get(url, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    TermService.prototype.getCourseSchedule = function (payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, params, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v2/course-schedules/get");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            }
                        };
                        params = { filter: payload };
                        return [4, axios_1.default.post(url, params, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    TermService.prototype.getTermByMajor = function (programId, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/terms/byMajor/").concat(programId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            },
                            params: params
                        };
                        return [4, axios_1.default.get(url, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return TermService;
}());
exports.TermService = TermService;
//# sourceMappingURL=data:application/json;base64,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